import type { ElementType, PropsWithChildren } from "react";

import type { PolymorphicProps } from "shared/types";

import { cn } from "shared/utils/cn";

type Props = {
  className?: string;
};

export const Breadcrumbs = (props: PropsWithChildren<Props>) => {
  const { className, children } = props;
  return (
    <div
      className={cn("flex flex-nowrap gap-x-3", "first:inline-flex", className)}
    >
      {children}
    </div>
  );
};

type ItemProps = {
  className?: string;
  isActive?: boolean;
};

const Item = <E extends ElementType>(
  props: PolymorphicProps<E, PropsWithChildren<ItemProps>>
) => {
  const { className, as = "div", isActive, children, ...restProps } = props;
  const Comp = as;

  return (
    <Comp
      {...restProps}
      className={cn(
        "cursor-pointer text-[26px] leading-6 font-semibold tracking-[0.45px] whitespace-nowrap text-white/30 outline-hidden transition-colors hover:text-white/50",
        isActive && "pointer-events-none text-white",
        className
      )}
    >
      {children}
    </Comp>
  );
};

Breadcrumbs.Item = Item;
